module.exports = __webpack_public_path__ + "static/media/多频极化信息接收与处理系统.26082791.png";